import { Box } from "@mui/material"

import { FC, Pagination, TripTeaserNew, type TripTeaserNewProps } from ".."

type TripCollectionProps = {
  items: TripTeaserNewProps[]
  currentPage?: number
  pages?: number
  onPageChange?: (pageNumber: number) => void
  showSpecialTag?: boolean
}

const TripCollection: FC<TripCollectionProps> = ({
  items = [],
  currentPage,
  pages,
  onPageChange,
  showSpecialTag = true,
}) => {
  const showPagination = currentPage && pages && pages > 1

  return (
    <>
      <Box
        display="grid"
        gridTemplateColumns={{
          xs: "minmax(0, 1fr)",
          md: "repeat(2, minmax(0, 1fr))",
          xl: "repeat(3, minmax(0, 1fr))",
        }}
        sx={{
          columnGap: { xs: 4, md: 10 },
          rowGap: { xs: 4, md: 10 },
        }}
      >
        {items?.map((data, i) => (
          <TripTeaserNew key={data.title || data.external_id || `trip-collection-${i}`} {...data} isSpecial={showSpecialTag} />
        ))}
      </Box>
      {showPagination && (
        <Box pt={{ xs: 15, md: 20 }}>
          <Pagination page={currentPage} count={pages} onPageChange={onPageChange} />
        </Box>
      )}
    </>
  )
}
export default TripCollection
